import { ChipOptionsDataType } from "../../components";
import { BillingConfigurationItem } from "../createClient/modelsAndSchemas/Models";

export const getPreferencesChipsFromBillingConfigs = (
  config: BillingConfigurationItem,
  employeeBandCheckboxLabel: string,
  employeeIDCheckboxLabel: string,
) => {
  let chipData: ChipOptionsDataType[] = [];
  if (config.hasEmployeeBand) {
    chipData.push({
      label: employeeBandCheckboxLabel,
      value: "employeeBandCheckbox",
    });
  }
  if (config.hasEmployeeId) {
    chipData.push({
      label: employeeIDCheckboxLabel,
      value: "employeeIDCheckbox",
    });
  }
  return chipData;
};
